import styled from 'styled-components';

const LabelsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export { LabelsContainer };
